import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/_services/api.service';


@Component({
  selector: 'app-officeLocations',
  templateUrl: './officeLocations.component.html',
  styleUrls: ['./officeLocations.component.scss']
})
export class OfficeLocationsComponent implements OnInit {
  HeadServices = false;
  markers: marker[] = [
	  {
      //HOA
		  lat: 34.0567361,
		  lng: -118.2459622,

	  },
	  {
      //North District
		  lat: 34.32188946052673,
		  lng: -118.49493026733398,

	  },
	  {
      //East District
		  lat: 34.0355747,
		  lng: -118.03935033,
	  },
	  {
      //South District
		  lat: 33.8047924888,
		  lng: -118.173543401,
	  },
	  {
      //West District
		  lat: 33.9848597,
		  lng: -118.3908681,
	  },
	  {
      //Lancaster
		  lat: 34.67001343,
		  lng: -118.12640381,
	  }
  ]
  constructor(private apiService: ApiService) { }

  mapClicked(event: MouseEvent) {

  }


  ngOnInit() {

  }

}

interface marker {
	lat: number;
	lng: number;

}
